import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Popup from 'components/Popup';
import InputDate from 'components/Inputs/inputDate';
import InputNumber from 'components/Inputs/inputNumber';
import InputSelect from 'components/Inputs/inputSelect';
import { Button } from 'xland-ui';
import { useSelector } from 'react-redux';
import { createInvestmentOperation } from 'modules/investmentAssets/repository';

function PopupEditOperation({
  asset,
  organization,
  operation: op = {},
  onSubmit,
  onClose,
}) {
  const literals = useSelector(state => state.i18n.literals.investmentAssets);
  const literalsCommon = useSelector(state => state.i18n.literals.common);
  const [operation, setOperation] = useState(op);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await createInvestmentOperation(asset, organization, operation);
      onSubmit();
      onClose();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Popup title={literals.operation} onClose={onClose}>
      <form onSubmit={handleSubmit}>
        <div className='row'>
          <InputDate
            preText={literalsCommon.date}
            className='col-md-6 col-12'
            value={operation.date}
            onChange={(date) => setOperation({ ...operation, date })}
          />
          <InputSelect
            preText={literalsCommon.status}
            className='col-md-6 col-12'
            value={operation.status}
            onChange={(status) => setOperation({ ...operation, status })}
            options={[
              { id: 'active', name: literals.active },
              { id: 'divested', name: literals.divested },
              { id: 'writtenOff', name: literals.writtenOff },
            ]}
          />
        </div>
        <div className='row'>
          <InputNumber
            preText={literals.invested}
            className='col-md-4 col-12'
            value={operation.invested}
            onChange={(invested) => setOperation({ ...operation, invested })}
          />
          <InputNumber
            preText={literals.realized}
            className='col-md-4 col-12'
            value={operation.realized}
            onChange={(realized) => setOperation({ ...operation, realized })}
          />
          <InputNumber
            preText={literalsCommon.value}
            className='col-md-4 col-12'
            value={operation.value}
            onChange={(value) => setOperation({ ...operation, value })}
          />
        </div>
        <div className='buttons'>
          <Button
            type='submit'
            text={literalsCommon.save}
            loading={loading}
          />
        </div>
      </form>
    </Popup>
  );
}

PopupEditOperation.propTypes = {
  operation: PropTypes.object,
  asset: PropTypes.object,
  organization: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default PopupEditOperation;
